import React, { useEffect, useState } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const OpenRelay = ({ selectedType, fieldsData, componentSourceOptions,
    selectedPorts, setSelectedPorts, savedData, setSavedData }) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Open_relay: {
                    ...prevData.Open_relay,
                    [key]: value
                }
            }
        })
    }

    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Open_relay.component_source.value}
        condition={savedData.Open_relay.condition}
        output={savedData.Open_relay.output}
        name={savedData.Open_relay.name}
        relay_mode={savedData.Open_relay.relay_mode}
        impulse_time={savedData.Open_relay.impulse_time}
        entry_exit_open_durations={savedData.Open_relay.entry_exit_open_durations}
        sensorAutolock={savedData.Open_relay.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default OpenRelay;